import { PstResultHistoryDto, PstResultRs } from '@domain/rs/phs/pst/result/PstResultRs';
import { LevelType } from '@domain/constant/levelType';
import { GradeType } from '@domain/constant/gradeType';
import { ProgramLanguageType } from '@domain/constant/programLanguageType';
import { VersionType } from '@domain/constant/phs/result/versionType';
import NumberUtil from '@utils/number/util';

export class PstResultHistoryVO {
  version: VersionType;
  priority: number; // 응시 회차
  score: number; // 점수
  elapsedTime: number; // 소요 시간
  language: ProgramLanguageType; // 사용 언어
  passedStep: number | null; // 통과단계
  passedStepText: string;
  finalPassedStep: number | null; // 검사결과 통과단계
  finalPassedStepText: string;
  accuracyText: string; // 정확성
  efficiencyText: string; // 효율성

  constructor(dto: PstResultHistoryDto, version: VersionType, finalPassedStep: number | null) {
    this.version = version;
    this.priority = dto.priority;
    this.score = Math.round(dto.score);
    this.elapsedTime = dto.elapsedTime;
    this.language = dto.language;
    this.passedStep = dto.passedStep;
    this.passedStepText = dto.passedStep ? `${dto.passedStep}단계` : '-';
    this.finalPassedStep = finalPassedStep;
    this.finalPassedStepText = NumberUtil.isNumber(finalPassedStep) ? `${finalPassedStep}단계` : '-';
    this.accuracyText = this.getPercentText(dto.accuracy);
    this.efficiencyText = this.getPercentText(dto.efficiency);
  }

  private getPercentText = (value: number | null) => {
    return NumberUtil.isNumber(value) ? `${value}%` : '-';
  };
}

export class PstResultVO {
  level: LevelType;
  grade: GradeType;
  version: VersionType;
  lastSubmitResult: PstResultHistoryVO | null;
  resultHistories: PstResultHistoryVO[];

  constructor(rs: PstResultRs) {
    this.level = rs.level;
    this.grade = rs.grade;
    this.version = rs.version;
    this.lastSubmitResult = rs.lastSubmitResult
      ? new PstResultHistoryVO(rs.lastSubmitResult, rs.version, rs.finalPassedStep)
      : null;
    this.resultHistories = rs.resultHistories.map(
      (resultHistory) => new PstResultHistoryVO(resultHistory, rs.version, rs.finalPassedStep),
    );
  }
}
